/*
 * Formats and displays a comment.
 */
import React, {Component} from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
//classes
import WbSession from "classes/Session.jsx";
// core components
import {
    Table,
    Row,
    Col,
    InputGroup,
    Input,
    Button,
    Spinner,
} from "reactstrap";
// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-solid-svg-icons';

class Comments extends Component {
    static contextType = WbSession;
    
    debug = false;
    state = {
        jobId: 0,
        now: null,
        exComments: [],
        // Saving new comment
        newCommentValue: '',
        fldChanged: false,
        saving: false,
        // Errors
        error: false,
        errorMsg: ""
    }
    
    constructor( {comments} ) {
        super();
                
        this.state.now = new Date();
        //this.state.jobId = pid; //FIXME: set job ID in Props
        this.state.exComments = comments;
    }
    
    formatDate(date) {
        let formatted = date;
        let commented = new Date(date);
        let now = this.state.now;
        
        //format the time portion
        var hr = commented.getHours();
        var min = commented.getMinutes();
        if (min < 10) {
            min = "0" + min;
        }
        var ampm = "AM";
        if( hr > 12 ) {
            hr -= 12;
            ampm = "PM";
        }
        let formattedTime = hr + ":" + min + ampm;
        //get the day name
        let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let day = days[commented.getDay()];
        
        
        const diffTime = Math.abs(now.getTime() - commented.getTime());
        if( diffTime <= (1000 * 3600 * 24) ){ //less than 1 day ago
            if( diffTime <= (1000 * 3600) ){ //less than 1hr ago
                //show time in minutes
                let minutes = Math.round(diffTime / (1000 * 60));
                formatted = minutes + " minutes ago";
                if( 1 === minutes ){
                    formatted = minutes + " minute ago";
                } else if( 0 === minutes ){
                    formatted = 'Just now';
                }
            } else { //more than 1 hr ago (show time in hours)
                let hours = Math.round(diffTime / (1000 * 3600));
                formatted = hours + " hours ago";
                if( 1 === hours ){
                    formatted = hours + " hour ago";
                }
            }
        } else if ( diffTime <= (1000 * 3600 * 24 * 2) ){ //more than 1 day, but less than 2 (ie. yesterday)
            formatted = "Yesterday at "+formattedTime;
        } else if( diffTime <= (1000 * 3600 * 24 * 6) ) { //less than 1 week ago
            formatted = day+" at "+formattedTime;
        } else {
            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            //format the date portion
            let date = commented.getDate();
            let month = months[commented.getMonth()];
            
            formatted = date + " " + month;
            if ( diffTime > (1000 * 3600 * 24 * 120) ) { //more than half a year ago (show year)
                formatted += " " + commented.getFullYear();
            }
            formatted += " at "+formattedTime;
        }
        
        return formatted; //FIXME:
    }
    
    tick() {
        this.setState(prevState => ({
            now: new Date()
        }));
    }
    
    componentDidMount() {
        this.interval = setInterval(() => this.tick(), 60000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }
    
    saveChanges = async () => {
        if(this.debug) console.log('Add comment triggered');
        const { exComments, jobId, newCommentValue } = this.state;
        const { fldId } = this.props;
        this.setState({saving: true});
        
        // Fetch all modified Meta fields
        let toSave = {};
        toSave[fldId] = newCommentValue;
        
        if(this.debug) console.log('Saving fields: ', toSave);
        
        const serverData = await this.context.updateJob( jobId, toSave );
        if(this.debug) console.log('Server response (save comment): ', serverData);
        
        let newState = {saving: false};
        if( typeof serverData.code !== "undefined" ){
            console.warn('Failed to update status.', serverData);
            let errorMsg = (serverData.message || "Failed to fetch job. Please try again later.");
            newState.error = true;
            newState.errorMsg = errorMsg;
        } else {
            newState.newCommentValue = '';
            newState.fldChanged = false;
            // extract comments from new $_post object
            if( typeof serverData[fldId] == "object" && serverData[fldId].length > exComments.length ){
                newState.exComments = serverData[fldId];
            }
        }
        
        this.setState(newState);
    };
    
    render() {
        const { exComments, newCommentValue, fldChanged, saving, error, errorMsg } = this.state;
        const { fldId, comments, ...rest } = this.props;
        
        if(this.debug) console.log('Existing comments: ', exComments, typeof exComments);
        
        return (
            <div className="wbComments" {...rest}>
                <Table className="cmTable">
                    <tbody>
                        {(!exComments.length) ? (
                            <tr key="0" className="cmTableRow">
                                <td className="cmTableCell">
                                </td>
                                <td className="cmTableCell">
                                    <p className="commentBody">
                                        No previous comments
                                    </p>
                                </td>
                            </tr>
                        ) : (
                            <>
                                {exComments.map( (comment, index) => {
                                    if( '' === comment.message ){
                                        return null;
                                    }
                                    return (
                                        <tr key={index} className="cmTableRow">
                                            <td className="cmTableCell">
                                                <FontAwesomeIcon className="cmIcon" icon={faComment} />
                                            </td>
                                            <td className="cmTableCell">
                                                <p className="commentBody">
                                                    {comment.message}
                                                </p>
                                                <div className="commentMeta">
                                                    <span className="commentUser">{comment.username} ({comment.useremail})</span>
                                                    <span className="commentDate">{this.formatDate(comment.timestamp)}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </>
                        )}
                    </tbody>
                </Table>
                <Row className="newCommentRow">
                    <Col xs="12" md="8">
                        <InputGroup className="newCommentFld">
                            <Input
                                type="textarea"
                                value={newCommentValue}
                                placeholder="Enter comment..."
                                onChange={(e)=>{
                                    if( !saving ){
                                        this.setState({fldChanged: true, newCommentValue: e.target.value});
                                    }
                                }}
                                className={"textInput "+((error)?"has-danger":'')}
                            />
                            {(''!=errorMsg) ? (
                                <p className="fld-description">{errorMsg}</p>
                            ) : (null)}
                        </InputGroup>
                    </Col>
                    <Col xs="12" md="4">
                        <Button
                            className={"mb-sm-3 mb-md-3 "}
                            color={(fldChanged)?"primary":"secondary"}
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                if( fldChanged && !saving ){
                                    this.saveChanges();
                                }
                            }}
                        >
                            {(!saving) ? (
                                <>Post Comment</>
                            ) : (
                                <Spinner color="secondary" />
                            )}
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

Comments.propTypes = {
    fldId: PropTypes.string,
    className: PropTypes.string,
    comments: PropTypes.arrayOf(PropTypes.object),
};

export default Comments;
